import { render, staticRenderFns } from "./EditDefaults.vue?vue&type=template&id=251fa001&scoped=true&"
import script from "./EditDefaults.vue?vue&type=script&lang=js&"
export * from "./EditDefaults.vue?vue&type=script&lang=js&"
import style0 from "./EditDefaults.vue?vue&type=style&index=0&id=251fa001&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251fa001",
  null
  
)

export default component.exports